import React, { useEffect, useState } from "react";
import EditPen from "../../assets/icons/Pen.png";
import { ReactComponent as DeletePen } from "../../assets/images/companyIcons/delete1.svg";
import Checkbox from "react-custom-checkbox";
import * as Icon from "react-icons/fi";
import { useUpdatePrimaryBillingAddressByBillingIdMutation } from "../../store/Billing/billingApiSlice";
import { useSelector } from "react-redux";

export const BillingAddress = ({
  addressData,
  userName,
  refetch,
  handleOpenAddBillingAddressPopup,
  onClick,
  onClickDelete,
  setHasAddressDataChanged,
  hasAddressDataChanged,
  handleOpenBillingPopup
}) => {
  // const [hasAddressDataChanged, setHasAddressDataChanged] = useState(false);
  const [data, setData] = useState([])

  useEffect(() => {
    refetch();
  }, [refetch, hasAddressDataChanged]);

  useEffect(() => {
    setData(addressData);
  }, [addressData])
  const { userInfo, token } = useSelector((state) => state.auth);
  const [checkboxStates, setCheckboxStates] = useState(
    data?.map((item) => item?.is_primary)
  );
  const [updatePrimaryBillingAddressByBillingId, { reset }] =
    useUpdatePrimaryBillingAddressByBillingIdMutation();

  const handlePrimaryBilling = async (index, billing_add_ID) => {
    const updatedIsPrimary = new Array(checkboxStates.length).fill(false);
    updatedIsPrimary[index] = true;
    setCheckboxStates(updatedIsPrimary);
    const data = {
      is_primary: true,
    };
    let updatePrimarty = await updatePrimaryBillingAddressByBillingId({ data, id: billing_add_ID, token });
    if (updatePrimarty) {
      // window.location.reload();
      setHasAddressDataChanged(!hasAddressDataChanged);
      handleOpenBillingPopup();
    }
    reset();
  };

  return (
    <div className=" flex flex-col items-center">
      <div>
        <h3 className="font-semibold sm:text-f24 mb-12">
          Change Billing Address
        </h3>
      </div>
      <div className="mb-12">
        {data?.map((i, index) => (
          <div
            key={index}
            className="flex items-center justify-between gap-6 mx-3"
          >
            <Checkbox
              icon={<Icon.FiCheck color="#FB512D" size={14} />}
              name={`my-input-${index}`}
              checked={checkboxStates[index]}
              onChange={() => handlePrimaryBilling(index, i.billing_add_ID)}
              borderColor="#9FA4A4"
              borderRadius="6px"
              style={{ cursor: "pointer" }}
            />
            <div className="col-span-1 mb-1 edit-bg p-3">
              <div className="col-span-1 w-full h-full edit-bg2"></div>
              <div
                style={{ width: "654px" }}
                className="flex justify-between  items-center"
              >
                <div className="flex flex-col gap-2.5">
                  <p style={{ fontSize: "14px" }} className="text-[#EBF0F3]">
                    {i?.companyName || userName}
                  </p>
                  <p style={{ fontSize: "14px" }} className="text-[#EBF0F3]">
                    {i?.mobile}
                  </p>
                  <p style={{ fontSize: "14px" }} className="text-[#EBF0F3]">
                    {i?.address_line_1} &nbsp;{i?.address_line_2}&nbsp;
                    {i?.city} &nbsp;{i?.postal_code} &nbsp;{i?.country}
                  </p>
                </div>
                <div className="flex justify-between  items-center gap-2">
                  <button
                    onClick={() => onClickDelete(i?.billing_add_ID)}
                    style={{
                      zIndex: 1,
                      width: "40px",
                      border: "1px solid rgba(235, 240, 243, 0.40)",
                      background: "rgba(255, 255, 255, 0.20)",
                    }}
                    className="bg-white-800 bg-opacity-25 font-semibold text-sm w-28 flex gap-2 items-center justify-center font-sans text-[#EBF0F3] p-3 rounded-md"
                  >
                    <DeletePen />
                  </button>
                  <button
                    onClick={() => onClick(i?.billing_add_ID)}
                    style={{
                      zIndex: 1,
                      width: "40px",
                      border: "1px solid rgba(235, 240, 243, 0.40)",
                      background: "rgba(255, 255, 255, 0.20)",
                    }}
                    className="bg-white-800 bg-opacity-25 font-semibold text-sm w-28 flex gap-2 items-center justify-center font-sans text-[#EBF0F3] p-3 rounded-md"
                  >
                    <img style={{ width: "16px" }} src={EditPen} alt="Edit" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <hr />
      <button
        onClick={handleOpenAddBillingAddressPopup}
        style={{ width: "730px" }}
        className="bg-primary px-4 py-2 text-center text-white text-f14  rounded w-full"
      >
        Add New Address
      </button>
      <div className="flex justify-between text-secondary pt-4 items-center"></div>
    </div>
  );
};
